import React from "react";
import { Navigate } from "react-router-dom";
import { Role } from "../../../enums/enums";
import { useDispatch, useSelector } from "react-redux";
import { AuthTypes } from "../../../redux/actions/_types";

export const ProtectedRoute = ({ role, children, setDataToast }) => {
  function message(message) {
    setDataToast({ active: true, type: "error", message });
  }
  const { decoded } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();

  function checkAuthorized() {
    if (role.includes(Role.All)) {
      return true;
    }

    if (decoded.role && role.includes(decoded.role)) {
      return true;
    } else {
      message("No está autorizado para ingresar.");
      localStorage.removeItem("tokenLog");
      dispatch({
        type: AuthTypes.LOGIN_FAILED,
      });
    }

    return false;
  }

  if (checkAuthorized()) {
    return children;
  } else {
    return <Navigate to={"/inicio"} replace />;
  }
};
